import { IQueryOptions, IExecutionOptions } from '../../models/query';
import { ITransformOptions } from '../../models/query/transforms';
import { TranslationHelper } from '../../helpers/TranslationHelper';
export abstract class BaseTransform {
	constructor(public options: ITransformOptions, public translationHelper: TranslationHelper) {

	}
	abstract execute(queryResponse: any, queryOptions: IQueryOptions, executionOptions: IExecutionOptions): any;
}